import React from "react";
import Multiselect from "multiselect-react-dropdown";
import { Accordion, Button, Col, Form } from "react-bootstrap";
import { useEditSubscription } from "./useEditSubscription";
import { IDasSubscription } from "../../../common/types/dasTypes";
import GroupSelectionFilter from "./groupSelectionFilter";
import TemplateSelectionFilter from "./templateSelectionFilter";
import CountySelectionFilter from "./countySelectionFilter";

interface IProps {
  dasSubscription: IDasSubscription;
}

const EditSubscription = (props: IProps) => {
  const { dasSubscription } = props;
  const {
    handleRadioChange,
    sendAutomatically,
    isTemplateDivSelected,
    handleTemplateClick,
    handleSubmit,
    handleAlertsSelect,
    handleAlertsRemove,
    alertsOptions,
    selectedAlertsOptions,
    handleGroupInputChange,
    groupSearchQuery,
    nodesToDisplay,
    handleDataFromTreeView,
    selectAllChecked,
    handleSelectAllChange,
    selectGroupState,
    setSelectGroupState,
    alertsPlaceholder,
    countyOptions,
    handleCountySelect,
    countyPlaceholder,
    selectedCountyOptions,
    isSaveClickable,
    groupsPlaceholder,
  } = useEditSubscription(dasSubscription);

  return (
    <Accordion.Body>
      <div className="integration-body">
        <Col sm={6}>
          <div className="integration-select">
            <Form.Label>Alert Types</Form.Label>
            <Multiselect
              displayValue="name"
              hideSelectedList
              onRemove={handleAlertsRemove}
              onSelect={handleAlertsSelect}
              options={alertsOptions}
              showCheckbox
              selectedValues={selectedAlertsOptions}
              placeholder={alertsPlaceholder}
            />
          </div>
        </Col>

        <Col sm={6}>
          <div className="integration-input-content">
            <div className="integration-input">
              <Form.Label htmlFor="cityType">County</Form.Label>
              <CountySelectionFilter
                handleCountySelect={handleCountySelect}
                countyOptions={countyOptions}
                selectedCountyOptions={selectedCountyOptions}
                countyPlaceholder={countyPlaceholder}
              />
            </div>
          </div>
        </Col>

        <GroupSelectionFilter
          handleGroupInputChange={handleGroupInputChange}
          groupSearchQuery={groupSearchQuery}
          nodesToDisplay={nodesToDisplay}
          handleDataFromTreeView={handleDataFromTreeView}
          selectAllChecked={selectAllChecked}
          handleSelectAllChange={handleSelectAllChange}
          selectGroupState={selectGroupState}
          setSelectGroupState={setSelectGroupState}
          groupsPlaceholder={groupsPlaceholder}
          checkedBox={dasSubscription.groups.map((group) => group.id)} 
        />
        <Col sm={12}>
          <div className="integration-radio">
            <Form.Label>Send Automatically?</Form.Label>
            <Form.Check
              inline
              type="radio"
              label="Yes"
              name={dasSubscription._id + "group1"}
              checked={sendAutomatically}
              onChange={() => handleRadioChange(true)}
            />
            <Form.Check
              inline
              label="No, needs approval."
              name={dasSubscription._id + "group1"}
              type="radio"
              checked={!sendAutomatically}
              onChange={() => handleRadioChange(false)}
            />
          </div>
        </Col>
        <TemplateSelectionFilter
          isTemplateDivSelected={isTemplateDivSelected}
          handleTemplateClick={handleTemplateClick}
        />
        <Col sm={12}>
          <div className="integration-footer">
            <Button disabled={!isSaveClickable} onClick={handleSubmit}>
              Save
            </Button>
          </div>
        </Col>
      </div>
    </Accordion.Body>
  );
};

export default EditSubscription;
